export class Conversation {
  id: string;
  displayName: string;
  stream: boolean;
}
